
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import ContactHero from './components/ContactHero';
import SubmissionForm from './components/SubmissionForm';

const ContactPage = () => {
  return (
    <div className="min-h-screen">
      <Navigation />
      <ContactHero />
      <SubmissionForm />
      <Footer />
    </div>
  );
};

export default ContactPage;
